import React, { useEffect, useState } from "react";
import styles from "./inputTag.module.scss";
import AlertIcon from "../../../assets/img/alert_icon.svg";
import AlertIconError from "../../../assets/img/alert_icon_error.svg";

interface InputTagProps {
    type?: "text" | "number";
    text?: string;
    name?: string;
    value: any;
    readOnly?: boolean;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    onChange?: (valor: any) => void;
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;
    onKeyUp?: (e: any) => void;
    id?: string;
    isErrored?: boolean;
    onKeyDown?: (e: any) => void;
    handleClick?: (e: any) => void;
    tagDelete?: (e: any) => void;
    onTag?: boolean;
}

export const InputTag: React.FC<InputTagProps> = ({
    className,
    text,
    name,
    type,
    value,
    readOnly,
    placeholder,
    onChange,
    onBlur,
    onFocus,
    onKeyUp,
    tagDelete,
    id,
    isErrored,
    onTag,
}) => {
    const [input, setInput] = useState("");
    const [tags, setTags] = useState([]);
    const [isKeyReleased, setIsKeyReleased] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false);

    const handleFocus = () => {
        setIsFocused(true);
    };
    const handlerChange = (e) => {
        const { value } = e.target;
        setInput(value);
    };
    const handleBlur = () => {
        setIsFocused(false);
    };
    const handleKeyUp = () => {
        setIsKeyReleased(true);
    };
    const handleReadOnly = () => {
        setIsReadOnly(true);
    };

    const onKeyDown = (e) => {
        const trimmedInput = value.trim();

        if (e == true && trimmedInput.length && !tags.includes(trimmedInput)) {
            // e.preventDefault();
            setTags((prevState) => [...prevState, trimmedInput]);
            setInput("");
            handleReadOnly();
        }
        const { key } = e;

        if (
            key === "Backspace" &&
            !input.length &&
            tags.length &&
            isKeyReleased
        ) {
            const tagsCopy = [...tags];
            const poppedTag = tagsCopy.pop();
            e.preventDefault();
            setTags(tagsCopy);
            setInput(poppedTag);
        }

        setIsKeyReleased(false);
    };

    const deleteTag = (index) => {
        setTags((prevState) => prevState.filter((tag, i) => i !== index));
        tagDelete(index);
        setIsReadOnly(false);
        onChange("");
        setInput("");
    };

    useEffect(() => {
        setInput(value);
    }, [value]);

    useEffect(() => {
        onTag && value.split(" ").length > 1 && onKeyDown(true);
    }, [value]);

    return (
        <div
            className={`
            ${styles.container}
            ${isErrored ? styles.container__errored : ""}
        `}
        >
            <div className={styles.ico}>
                <img
                    src={isErrored ? AlertIconError : AlertIcon}
                    alt="alert-icon"
                />
            </div>
            {tags.map((tag, i) => (
                <div key={i} className={styles.tag}>
                    <span>{tag}</span>
                </div>
            ))}
            <input
                onKeyDown={onKeyDown}
                onKeyUp={(e) => {
                    onKeyUp?.(e.target);
                    handleKeyUp;
                }}
                autoComplete="off"
                type={type ?? "text"}
                value={input}
                id={id}
                name={name}
                readOnly={isReadOnly}
                placeholder={!isReadOnly ? placeholder : ""}
                onBlur={(e) => {
                    onBlur?.(e.target.value);
                    handleBlur();
                }}
                onChange={(e) => {
                    onChange?.(e.target.value);
                    handlerChange(e);
                }}
                onFocus={(e) => {
                    onFocus?.(e.target.value);
                    handleFocus();
                }}
                className={`${styles.input} ${onFocus ? "" : ".input:focus"}`}
            />
            {tags.map((tag, i) => (
                <div key={i} className={styles.tag}>
                    <button onClick={() => deleteTag(i)}>X</button>
                </div>
            ))}
        </div>
    );
};
